import type { AnyAction } from "@reduxjs/toolkit";
import type { EditorRootState } from "@v1/store/store";

import { selectDraftElementIsPublished } from "@v1/reducers/core-reducer";
import { modalStore } from "@v2/store/modalStore";
import { getBillingPlanErrorUsage } from "@v2/store/utils/getBillingPlanErrorUsage";
import { getErrorDetails } from "@v2/utils/get-error-details";

import listenerMiddleware from "./listener";

// Bridge RTKQ error actions to Zustand modal store
listenerMiddleware.startListening({
  predicate: (action) => {
    return (
      getErrorDetails({
        type: "rsaaOrRtkQueryAction",
        action: action as AnyAction,
      }) != null
    );
  },
  effect: (action, listenerApi) => {
    const details = getErrorDetails({
      type: "rsaaOrRtkQueryAction",
      action: action as AnyAction,
    });
    const isElementPublished = selectDraftElementIsPublished(
      listenerApi.getState() as EditorRootState,
    );
    modalStore.getState().actions.handleErrorDetails({
      details,
      billingPlanErrorUsage: getBillingPlanErrorUsage(
        (action as AnyAction).payload,
      ),
      isElementPublished: Boolean(isElementPublished),
    });
  },
});
